import { Text, StyleSheet } from '@react-pdf/renderer';
import { theme } from '../theme';

const style = StyleSheet.create({
  pdfTextStyle: {
    width: '100%',
  },
  pdfAccentedStyle: {
    color: theme.colors.primaryT1,
    fontWeight: 'bold',
  },
  pdfLeasingTypeTitleStyle: {
    color: theme.colors.primaryW,
    textTransform: 'uppercase',
    textAlign: 'right',
  },
  pdfUpperCase: {
    textTransform: 'uppercase',
  },
});

export const PdfText: React.FC<{
  accented?: boolean;
  isLeasingTypeTitle?: boolean;
  isUpperCase?: boolean;
}> = ({ accented, isLeasingTypeTitle, isUpperCase, ...props }) => (
  <Text
    style={[
      style.pdfTextStyle,
      accented ? style.pdfAccentedStyle : {},
      isLeasingTypeTitle ? style.pdfLeasingTypeTitleStyle : {},
      isUpperCase ? style.pdfUpperCase : {},
    ]}>
    {props.children}
  </Text>
);
